import {
  BaSeButton,
  BaSeGrid,
  BaSeGridItem,
  BaSeInput,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../hooks/services/interview-service';

function ConfirmManualEvalate({
  statusInterview,
  handleCancel,
  closeModal,
  emitEvent,
  setJustificationDefault,
  manualEvaluationData,
  justificationDefault,
  id,
  totalManualEvaluate,
}) {
  const [isLoading, setIsLoading] = React.useState(false);
  const { putEvaluateByCceScore } = useInterviewService();
  const { handleAttention, handleSuccess } = useMessage();
  const [justification, setJustification] =
    React.useState(justificationDefault);

  const returnValueOfList = React.useCallback(
    (desc) => {
      const result = manualEvaluationData.find(
        (l) => l.descProfileItem === desc,
      );
      return +result.scoreManualEvaluation ?? 0;
    },
    [manualEvaluationData],
  );

  const handleConfirmManualEvaluete = React.useCallback(() => {
    setIsLoading(true);
    const dto = {
      interviewId: id,
      persistenceScore: returnValueOfList('Persistência'),
      informationSearchScore: returnValueOfList('Busca de informação'),
      settingGoalsScore: returnValueOfList('Estabelecimento de metas'),
      calculatedRiskScore: returnValueOfList('Correr riscos calculados'),
      persuasionContactNetworkScore: returnValueOfList(
        'Persuasão e rede de contatos',
      ),
      independenceTrustScore: returnValueOfList(
        'Independência e autoconfiança',
      ),
      planMonitorScore: returnValueOfList(
        'Planejamento e monitoramento sistemático',
      ),
      opportunityIniciativeScore: returnValueOfList(
        'Busca de oportunidades e Iniciativa',
      ),
      qualityEfficiencyScore: returnValueOfList(
        'Exigência de qualidade e eficiência',
      ),
      commitmentScore: returnValueOfList('Comprometimento'),
      justification,
    };

    setJustificationDefault(justification.trim());
    putEvaluateByCceScore(dto)
      .then(() => {
        setIsLoading(false);
        emitEvent('confirmar');
        closeModal('confirmar');
        handleSuccess('Operação realizada com sucesso!');
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [
    id,
    returnValueOfList,
    handleSuccess,
    justification,
    setJustificationDefault,
    putEvaluateByCceScore,
    emitEvent,
    closeModal,
  ]);

  return (
    <BaSeGrid>
      <BaSeGridItem size={12}>
        <BaSeInput
          label="Resultado:"
          //value={getStatusInterview(statusInterview)}
          value={totalManualEvaluate() >= 60 ? 'Apto' : 'Não apto'}
          isDisabled
        />
      </BaSeGridItem>

      <BaSeGridItem size={12}>
        <BaSeTextArea
          label="Justificativa:"
          value={justification}
          onChange={setJustification}
          placeholder="Descreva sua justificativa"
          rows={8}
          hasCounter="chars"
          maxLength={250}
          counterMaxLength={250}
        />
      </BaSeGridItem>
      <BaSeGridItem size={12}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <BaSeButton
            value="Confirmar"
            isDisabled={isLoading}
            type="primary"
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            onClick={() => {
              if (justification.length === 0) {
                handleAttention('Campo obrigatório não informado.');
                return;
              }
              handleConfirmManualEvaluete();
            }}
          />
          <BaSeButton
            value="Cancelar"
            type="secondary"
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            onClick={() => {
              handleCancel();
              closeModal();
            }}
          />
        </div>
      </BaSeGridItem>
    </BaSeGrid>
  );
}

export default ConfirmManualEvalate;
